import { ErrorBoundary } from '@sentry/gatsby';
import { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { styled } from 'twin.macro';

const StyledRecaptcha = styled.div`
  visibility: hidden;
  height: 0;
  overflow: hidden;
  position: absolute;
`;

const GoogleRecaptcha = forwardRef<ReCAPTCHA>((_, ref) => {
  return (
    <ErrorBoundary>
      <StyledRecaptcha>
        <ReCAPTCHA
          ref={ref}
          size="invisible"
          sitekey={process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY ?? ''}
          badge="inline"
        />
      </StyledRecaptcha>
    </ErrorBoundary>
  );
});

export default GoogleRecaptcha;
